export const PRO_TEXT =
  '商家必备营销神器，为商家提供VIP式服务，完成店铺装修、营销、渠道拓展、店铺管理等全流程服务，省心省力。'

export const PRO_HOTEL_TEXT =
  '酒店必备营销神器，为商家提供VIP式服务，轻松完成线上开店、营销转化、精准运营、酒店管理。'
